<!--
  pwa-instructions.component.html
  The install instructions as content only — intro, five numbered steps (heading,
  body, screenshot) and a closing note. Deliberately carries no header/toolbar or
  close button so the host surface (the /install-help page or the modal) supplies
  its own chrome. Step numbers come from the loop index, not the data.
-->

<div class="install-instructions">

  <!-- Heading: shown on the public page; the modal blanks it because its
       toolbar title already carries the same words. -->
  <h1 class="install-heading" *ngIf="heading">{{ heading }}</h1>

  <p class="install-intro">{{ intro }}</p>

  <!-- The steps. Each is a card: number + heading, body copy, screenshot. -->
  <ol class="install-steps">
    <li class="install-step" *ngFor="let step of steps; let i = index">

      <div class="install-step-head">
        <span class="install-step-number" aria-hidden="true">{{ i + 1 }}</span>
        <h2 class="install-step-title">Step {{ i + 1 }}: {{ step.title }}</h2>
      </div>

      <p class="install-step-body">{{ resolveBody(step.body) }}</p>

      <!-- loading="lazy": five phone screenshots is most of this page's weight,
           and the later ones are well below the fold. -->
      <img
        class="install-step-image"
        [src]="step.image"
        [alt]="step.alt"
        loading="lazy">

    </li>
  </ol>

  <!-- Closing note -->
  <div class="install-closing">
    <ion-icon name="checkmark-circle-outline" class="install-closing-icon" aria-hidden="true"></ion-icon>
    <p class="install-closing-text">{{ closing }}</p>
  </div>

</div>
